export enum ConsultationMessageType {
  Text = 'text',
  Images = 'images',
  VoiceNote = 'voice-note',
  Prescription = 'prescription',
  RichText = 'rich-text',
}
